import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { ScheduleWeeks } from "@/hooks/useScheduleWeeks";
import { ScheduleLoadFallback } from "./ScheduleLoadFallback";

type Props = { panelDay: Pick<ScheduleWeeks, "isLoading" | "isError" | "refetch">; dataTestId: string };

/**
 * What a panel shows before its day is on screen: a spinner while the day's weeks load, the error with Retry when
 * they fail, and nothing when the day has no staffing row (the panel never opened on such a day).
 */
export const PanelDayFallback: FC<Props> = ({ panelDay, dataTestId }) => {
	const { t } = useTranslation();
	return <ScheduleLoadFallback load={panelDay} errorTitle={t("staffing.changes.schedule.load.failed")} dataTestId={dataTestId} />;
};
